module.exports = __webpack_public_path__ + "media/components/maps/apps/icons/somewhatPositive-8cc7b5386d5af10c6ceec0a264cb4e24.png";